import { APIPaginatedRequest, getFetcher } from "shared/api/api";
import client from "shared/api/axios";
import { createURL } from "shared/api/utils";

const VECTOR_CLUSTERS_BASE_ROUTE = "vectorClusters";

export interface VectorCluster {
  ID: string;
  createdAt: string;
  description: string | null;
  centroid: number[] | null;
  radius: number | null;
}

interface GetVectorClusterRequest {
  id: string;
}

const listVectorClustersRequestURI = (params: APIPaginatedRequest): string =>
  client.getUri({
    method: "GET",
    url: VECTOR_CLUSTERS_BASE_ROUTE,
    params,
  });

export const listVectorClusters = (args: APIPaginatedRequest) =>
  getFetcher<VectorCluster[]>(listVectorClustersRequestURI(args));

const getVectorClusterRequestURI = ({
  id,
  ...params
}: GetVectorClusterRequest): string =>
  client.getUri({
    method: "GET",
    url: createURL([VECTOR_CLUSTERS_BASE_ROUTE, id]),
    params,
  });

export const getVectorCluster = (args: GetVectorClusterRequest) =>
  getFetcher<VectorCluster>(getVectorClusterRequestURI(args));
